module.exports = __webpack_public_path__ + "img/cg.26b1c24c.svg";